
export function timeMapping(data:any) {

    // Convertimos a números
  let horasNumber = parseInt(data.hour, 10);
  let minutosNumber = parseInt(data.minutes, 10);
  // Creamos un objeto de fecha con las horas y minutos
  let date = new Date();
  date.setHours(horasNumber);
  date.setMinutes(minutosNumber);
  
  date.setMinutes(date.getMinutes() - 30);
  // Obtenemos los valores de horas y minutos ajustados
  let nuevasHoras = date.getHours() as any;
  let nuevosMinutos = date.getMinutes()as any;
  
  // Si quieres que siempre devuelva dos dígitos
  nuevasHoras = nuevasHoras.toString().padStart(2, '0');
  nuevosMinutos = nuevosMinutos.toString().padStart(2, '0');
  return nuevasHoras+":"+nuevosMinutos
  };
  

  /**
 * Filtro para obtener incidencias de pista
 */
export function getRealTimeTrains(el: any,icon:any,background:any,hour:string,minutes:string) {
    let result=null;
    if(icon==="cercanias"){
    result={
      origin:el.Origin.name,
      tag:icon.toUpperCase()+" "+el.number,
      background:background,
      hour:hour,
      minutes:minutes,
      number:el.number,
      originID: Number(extractValueByKey(el.Origin.Notes.Note,"EK")),
      destinationID:Number( extractValueByKey(el.Destination.Notes.Note,"EK")),
      tripDate:Number(transformDateIncidents(el.Origin.date)),
    }
  }
    return result
  }
  
  
  export function mapTrainSchedulesByNumber(data:any, infoTrain:any) {
  let body;

  body={
    ...infoTrain,
    schedules: data.trayectoHorariosCercanias.flatMap((obj:any) => 
      obj.tramos
        .filter((tramo:any )=>tramo.lineaDestino && infoTrain.number.includes(tramo.lineaDestino))
        .map((tramo:any ) => tramo.horario)
    )
  }
   return body
  
  }
  

  export function formatFecha(fechaString:any) {

    const fecha = new Date(fechaString); // Convierte el string en un objeto Date
    const dia = String(fecha.getDate()).padStart(2, '0'); // Obtiene el día con dos dígitos
    const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Obtiene el mes con dos dígitos (los meses empiezan desde 0)
    const anio = fecha.getFullYear(); // Obtiene el año
    return `${dia}/${mes}/${anio}`; // Formatea la fecha
  };


export function transformDateIncidents(dateStr:String) {
  // Split the string by the '-' delimiter
  const [year, month, day] = dateStr.split('-');

  // Concatenate the parts in the desired order and format
  const formattedDate = `${year}${month}${day}`;

  return formattedDate;
};


  export function extractValueByKey(array:any,key:string) {
    // Find the object with the specified `key`
    const foundObject = array?.find((obj:any) => obj.key === key);

    // Return the `value` if the object is found; otherwise return null or a default value
    return foundObject ? foundObject.value : null;
};


  